
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCalendarDateGoogle as ObiCalendarDateGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-calendar-date-google.js';
 
 
 

 
 export const ObiCalendarDateGoogle = createComponent({
   react: React,
   tagName: 'obi-calendar-date-google',
   elementClass: ObiCalendarDateGoogleElement,
   events: {
     
   }
  });
 
 